import {Outlet} from "react-router-dom";

const Banners = () => {
    return <Outlet/>;
};

export default Banners;
